import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class PanelBody extends PureComponent {
  render() {
    const { children, className, access, ...others } = this.props;
    const cls = classNames({
      "weui-panel__bd": true
    }, className);

    return (
      <div className={ cls } { ...others }>{ children }</div>
    );
  }
}
